export function liveRegion() {
  return document.querySelector('[role="alert"][aria-live="assertive"]');
}
export function politeLiveRegion() {
  return document.querySelector('[role="alert"][aria-live="polite"]');
}
export default liveRegion;